"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataLayerListById = getDataLayerListById;
exports.getDataLayerObject = getDataLayerObject;
exports.getDataLayerValue = getDataLayerValue;
exports.inDataLayer = inDataLayer;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var nodeExplorer = function nodeExplorer(node, key, val, ret) {
  var k, r, j;
  if (!!node && node[key] !== undefined && typeof node[key] !== "function") {
    if (!!val && node[key] === val) {
      return node;
    }
    if (!!ret) {
      ret.push(node);
    }
    if (!ret && !val) {
      return node;
    }
  }
  if (node instanceof Array) {
    for (k = node.length - 1; k >= 0; k -= 1) {
      if (!!ret) {
        nodeExplorer(node[k], key, false, ret);
      } else {
        r = nodeExplorer(node[k], key, val);
        if (r !== undefined) {
          return r;
        }
      }
    }
  } else if ((0, _typeof2["default"])(node) === "object") {
    for (j in node) {
      if (node.hasOwnProperty(j)) {
        if (!!ret) {
          nodeExplorer(node[j], key, false, ret);
        } else {
          r = nodeExplorer(node[j], key, val);
          if (r !== undefined) {
            return r;
          }
        }
      }
    }
  }
  if (!!ret) {
    return ret;
  }
};

/**
 * Get the dataLayer value of a given key.
 * @param {Object|Array} dataLayer - The context to execute the search
 * @param {String} key - The key to find into the dataLayer
 * @return {*} Return the value that matches the key, default value is an empty string.
 */
function getDataLayerValue(dataLayer, key) {
  var res = nodeExplorer(dataLayer, key);
  return !!res ? res[key] : "";
}

/**
 * Return the list on the dataLayer, matching the key passed in params.
 * @param {Object|Array} dataLayer - The context to execute the search
 * @param {String} key - The key to find into the dataLayer
 * @return {Array} Return the value that matches the key, default value is an empty array.
 */
function getDataLayerListById(dataLayer, key) {
  /*var obj = dataLayer.slice()
                         .reverse()
                         .filter(function(item){
                             return item.products !== undefined
                         })[0];
  (!!obj ? obj.products || [] ).map(function(item){
   return typeof item.affichagetype === "string" ? item.affichagetype : item.affichagetype[0].name
  });*/
  var res = nodeExplorer(dataLayer, key, false, []);
  return !!res ? res : [];
}

/**
 * Return the object on the dataLayer, matching the combo
 * key:value passed in params.
 * @param {Object|Array} dataLayer - The context to execute the search
 * @param {String} key - Name of the key in the dataLayer dataLayer
 * @param {String} val - Value to test with the key's name
 * @return {Object}
 * Return the object of the dataLayer matching the combo key:value,
 * else return false.
 */
function getDataLayerObject(dataLayer, key, val) {
  var res = nodeExplorer(dataLayer, key, val);
  return !!res ? res : false;
}

/**
 * Check if an element exist in the dataLayer.
 * @param {Object|Array} dataLayer - The context to execute the search
 * @param {String} key - Name of the key in the dataLayer dataLayer
 * @param {String} val - Value to test with the key's name
 * @return {Boolean}
 * Return True if the combo key: value exist in the dataLayer array,
 * else return false.
 */
function inDataLayer(dataLayer, key, val) {
  var res = nodeExplorer(dataLayer, key, val);
  return !!res ? true : false;
}